import download from "./download.js";

function browserType() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1;
    if (isOpera) {
        return "Opera"
    }; //判断是否Opera浏览器
    if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
    } //判断是否Firefox浏览器
    if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
    }
    if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } //判断是否Safari浏览器
    if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        return "IE";
    }; //判断是否IE浏览器
    if (userAgent.indexOf("Trident") > -1) {
        return "Edge";
    } //判断是否Edge浏览器
};

// function download(src) {
//     var alink = document.createElement('a');
//     alink.setAttribute("href", src);
//     alink.setAttribute("download", '');
//     alink.setAttribute('target', '_blank');
//     //var evObj = document.createEvent('MouseEvents');
//     //evObj.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, true, false, 0, null);
//     //alink.dispatchEvent(evObj);
//     document.body.appendChild(alink);
//     alink.click();
//     document.body.removeChild(alink);
// };

function SaveAs5(imgURL) {
    var oPop = window.open(imgURL, "", "width=1, height=1, top=5000, left=5000");
    for (; oPop.document.readyState != "complete";) {
        if (oPop.document.readyState == "complete") break;
    }
    oPop.document.execCommand("SaveAs");
    oPop.close();
};

function downLoadFile(url, name) {
    if (browserType() === "IE" || browserType() === "Edge") {
        SaveAs5(url);
    } else {
        download(url, name);
    }
};

/*
 *多维数组数组扁平化
 */
function arrayChildrenFlatten(array, result) {
    if (!result) result = [];
    for (var i = 0; i < array.length; i++) {
        var item = array[i];
        result.push(item);
        if (item.children && item.children.length > 0) {
            result = arrayChildrenFlatten(item.children, result);
        }
    }
    return result;
}

/**
 * 数组减法，去除相同的数组
 * @param {*} source 
 * @param {*} array 
 * @param {*} field 对比的字段
 */
function getMinusArray(source, array, field) {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < array.length; i++) {
        obj[array[i][field]] = 1;
    }
    for (var j = 0; j < source.length; j++) {
        if (!obj[source[j][field]]) {
            obj[source[j][field]] = 1;
            result.push(source[j]);
        }
    }
    return result;
}

function eachParent(node, tree_data, parent_prop, child_prop) {
    if (node[parent_prop] == null) return null;
    for (let i = 0; i < tree_data.length; i++) {
        const item = tree_data[i];
        if (item[child_prop] == node[parent_prop]) {
            return item;
        } else {
            if (item.children && item.children.length > 0) {
                let p = eachParent(node, item.children, parent_prop, child_prop);
                if (p != null)
                    return p;
            }
        }
    }
    return null;
};
//获取树的Parent
function getTreeParent(node, tree_data, parent_prop, child_prop) {
    return eachParent(node, tree_data, parent_prop, child_prop);
};
//获取树的节点的兄弟节点结合
function getTreeSiblings(node, tree_data, parent_prop, child_prop) {
    let parent = eachParent(node, tree_data, parent_prop, child_prop);
    if (parent == null)
        return tree_data;
    return parent.children;
}

function bin2hex(str) {
    var result = "";
    for (let i = 0; i < str.length; i++) {
        result += int16_to_hex(str.charCodeAt(i));
    }
    return result;
}

function int16_to_hex(i) {
    var result = i.toString(16);
    var j = 0;
    while (j + result.length < 4) {
        result = "0" + result;
        j++;
    }
    return result;
}
/**
 * js获取浏览器唯一标识（同电脑不同浏览器值不同）
 * // 原文链接：https://blog.csdn.net/javakeffer/article/details/48803165
 */
function getBrowserClientId() {
    var clientId = window.localStorage.getItem("ClientId");
    if (!clientId) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var txt = window.origin;
        ctx.textBaseline = "top";
        ctx.font = "14px 'Arial'";
        ctx.textBaseline = "tencent";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText(txt, 4, 17);
        var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
        var bin = atob(b64);
        var crc = bin2hex(bin.slice(-16, -12));
        clientId = crc + '_' + Number(Math.random().toString().substr(3, 10) + Date.now()).toString(36);
        window.localStorage.setItem("ClientId", clientId);
    }
    return clientId;
}

function showProgressColors(percentage) {
    if (percentage < 50) {
        return "#e6a23c";
    } else if (percentage < 100) {
        return "#409eff";
    } else {
        return "#67c23a";
    }
}

function getParams(str) {
    let obj = {};
    let arr = str.split('?');
    if (str && arr.length > 1) {
        let queryArray = arr[1].split('&');
        queryArray.map((query) => {
            // param=value 以 = 分割
            let temp = query.split('=');
            if (temp.length > 1) {
                // 收集参数
                obj[temp[0]] = temp[1];
            }
        })
    }
    return obj;
}

function routerJump(name, params) {
    if (!params) params = {};
    var obj = getParams(name);
    for (let k in obj) {
        params[k] = obj[k];
    }
    this.$router.push({
        name: name.split('?')[0],
        params: params
    });
}

function textBecomeImg(text, imageSize, fontsize, fontcolor, backgroundcolor) {
    var defaultSize = 30;
    var dev = 0;
    if (text.length == 1) {
        defaultSize = 30;
        dev = 7;
    } else if (text.length == 2) {
        defaultSize = 18;
        dev = 12;
    } else if (text.length == 3) {
        defaultSize = 12;
        dev = 16;
    }
    imageSize = imageSize ? imageSize : 40;
    fontsize = fontsize ? fontsize : defaultSize;
    fontcolor = fontcolor ? fontcolor : '#FFF';

    var canvas = document.createElement('canvas');
    canvas.height = imageSize;
    canvas.width = imageSize;

    //根据文字自动变背景颜色
    var defaulColor = '';
    defaulColor += parseInt(text.charCodeAt(0), 10).toString(16);
    defaulColor = '#' + defaulColor.slice(0, 3);

    backgroundcolor = backgroundcolor ? backgroundcolor : defaulColor;
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    //画背景
    context.fillStyle = backgroundcolor;
    context.fillRect(0, 0, canvas.width, canvas.height);
    //画文字
    context.fillStyle = fontcolor;
    context.font = fontsize + "px Arial";
    context.textBaseline = 'middle';
    var text_w = context.measureText(text).width;
    context.fillText(text, canvas.width / 2 - text_w / 2, fontsize / 2 + dev);
    //转图片
    var dataUrl = canvas.toDataURL('image/png');
    return dataUrl;
}

function colorRenderFilter(id, renderData) {
    var name = id;
    var bgcolor = "";
    var color = "";
    if (renderData) {
        var displayName = renderData.filter(item => item.value == id);
        if (displayName.length) {
            name = displayName[0].display;
            bgcolor = displayName[0].bgcolor;
            color = bgcolor ? "#000" : "";
        }
    }
    return `<div style="color:${color};background:${bgcolor};padding:0 5px;">${name}</div>`;
}

function dateFilter(value, format) {
    if (!value || value == "9999-12-31") return "";
    if (typeof value == "string" && value.indexOf('T') == -1) {
        var reg = new RegExp('-', "g")
        value = value.replace(reg, '/')
    }
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? "0" + MM : MM;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let m = date.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = date.getSeconds();
    s = s < 10 ? "0" + s : s;

    const opt = {
        "y+": y, // 年
        "M+": MM, // 月
        "d+": d, // 日
        "H+": h, // 时
        "m+": m, // 分
        "s+": s // 秒
    };
    if (format) {
        let fmt = format;
        let ret;
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], opt[k])
            };
        };
        return fmt
    }
    return y + "-" + MM + "-" + d + " "; //默认返回这个，需要格式请加格式
}

//后台由dictionary转实体时由于GMT+0800格式的字符串转换不了，需要转化一下
function convertStringTimeToDate(obj) {
    Object.keys(obj).forEach(key => {
        if (typeof obj[key] == "string" && obj[key].indexOf('GMT+0800') > -1) {
            //转换成另一种时间格式
            console.log('1')
            obj[key] = dateFilter(obj[key], "yyyy/MM/dd HH:mm:ss");
        }
    })
    return obj;
}

function convertListStringTimeToDate(obj) {
    for (var i = 0; i < obj.length; i++) {
        obj[i] = convertStringTimeToDate(obj[i]);
    }
    return obj;
}

//是否有权限
function hasElement(element_code, menu_link) {
    //权限按钮与页面在同一页面时可以不用传menu_link
    if (element_code) {
        const routerName = menu_link ? menu_link : vm.$route.name;
        var hasEl = vm.$store.state.navTabs.menuTreeListFlatten.filter(item => item.menu_link == routerName);
        if (hasEl.length) {
            hasEl = hasEl[0].check_elements.filter(item => item.element_code == element_code);
            if (hasEl.length) {
                //匹配到权限
                return true;
            }
        }
    }
    //没有匹配到权限
    return false;
}

function hasFunciton(menu_link) {
    return vm.$store.state.navTabs.menuTreeListFlatten.filter(item => item.menu_link == menu_link && item.menu_type == 'function').length > 0
}

//是否有权限
function hasPermision(element_code, menu_link) {
    if (element_code) {
        if (hasElement(element_code, menu_link)) {
            return "";
        }
    }
    return "display:none;";
}

//自动生成rgb颜色
function autoColor(name) {
    var backgroundcolor = "";
    if (name) {
        //保证一个文字的时候也有颜色
        var sliceIndex = 0;
        if (name.length == 1) sliceIndex = 3;
        else sliceIndex = 2;
        for (let index = 0; index < name.length; index++) {
            backgroundcolor += parseInt(name[index].charCodeAt(0), 10).toString(16).slice(0, sliceIndex);
        }
        backgroundcolor = "#" + backgroundcolor.slice(0, 3);
    }
    return backgroundcolor;
}

function calculateDelayDay(val) {
    var period = 0;
    if (val) {
        period = Math.ceil((new Date().getTime() - new Date(val).getTime()) / (24 * 60 * 60 * 1000));
    }
    return period;
}

// Method that will return the data type for any structure passed to it
function getDataType(data) {
    // Use the objects toString method on the data.
    // This will return something like [object String]
    // Then we use .slice to grab the last portion of it (in this case the "string" bit)
    return Object.prototype.toString.call(data).slice(8, -1);
}

// Create a method to detect whether an object contains a circular reference
function isCyclic(data) {

    // Create an array that will store the nodes of the array that have already been iterated over
    let seenObjects = [];

    function detect(data) {
        // If the data pass is an object
        if (data && getDataType(data) === "Object") {

            // If the data is already in the seen nodes array then we know there is a circular reference
            // Therefore return true
            if (seenObjects.indexOf(data) !== -1) {
                return true;
            }

            // Add the data to the seen objects array
            seenObjects.push(data);

            // Begin iterating through the data passed to the method
            for (var key in data) {
                // Recall this method with the objects key
                if (data.hasOwnProperty(key) === true && detect(data[key])) {
                    return true;
                }
            }
        }
        return false;
    }

    // Return the method
    return detect(data);
}

/**
 * 深拷贝，类似于JSON.parse(JSON.stringify( ))
 * @param {*} data 
 */
const deepClone = function (data) {
    // If the data is null or undefined then we return undefined
    if (data === null || data === undefined) {
        return undefined;
    }

    // Get the data type and store it
    const dataType = getDataType(data);

    // If the data passed is a date object
    if (dataType === "Date") {
        // Create a new date object and set the time to what it was previously
        let clonedDate = new Date();
        clonedDate.setTime(data.getTime());

        return clonedDate;
    }

    // If the data passed is an object
    if (dataType === "Object") {
        // Check for circular references, if there are then we just return the un-cloned data.
        if (isCyclic(data) === true) {
            return data;
        }

        // Create a new object that will store our copied data
        let copiedObject = {};

        // Iterate over the objects keys
        for (let key in data) {
            // Clone the keys of each of the objects so that we can deeply copy and nested data structures
            // For example if an object has a key value that is an array
            // Add this cloned key value to the copiedObject we created earlier
            copiedObject[key] = deepClone(data[key]);
        }

        // Return the deeply copied object
        return copiedObject;
    }

    // If the data is an array
    if (dataType === "Array") {
        // Create a new array that will have no references to the one we want to copy
        let copiedArray = [];

        // Iterate over the arrays elements
        for (var i = 0; i < data.length; i++) {
            // Push the arrays elements to this new array
            // First recall this method with the elements
            // This is so arrays of objects and other nested data structures get correctly cloned.
            copiedArray.push(deepClone(data[i]));
        }

        // Return the cloned array
        return copiedArray;
    }

    // If it's any other data type like a string or number, they don't need cloning so we just return them
    else {
        return data;
    }
}

const getWeekSpanDate = (weekNum, year) => {
    year = year || new Date().getFullYear();
    var yearFirstDay = new Date(year, 0, 1);
    var addDay = 0;
    //把开始的几天算在上一年的周次里
    if (yearFirstDay.getDay() != 1) {
        addDay = 7 - yearFirstDay.getDay() + 1;
    }
    //把算在上一年周次的天加回来
    var weekSpanNum = weekNum * 7 + addDay;
    var weekStartDate = new Date(new Date(year, 0, 1).setDate(weekSpanNum - 6));
    var weekEndDate = new Date(new Date(year, 0, 1).setDate(weekSpanNum));
    return {
        start: weekStartDate,
        end: weekEndDate
    }
}

//单列的groupby
const groupBy = (array, name, filterMethod = function (a) { return a }) => {
    let groups = [];
    array.forEach((item) => {
        let groupName = filterMethod(item[name]);
        var hasgroup = groups.filter((item) => item.group == groupName);
        if (hasgroup.length) {
            hasgroup[0].value.push(item);
        } else {
            groups.push({
                group: groupName,
                value: [item],
            });
        }
    });
    return groups;
}
/**
 * 展开或折叠table的树节点
 * @param {*} data 
 * @param {*} tableRef 
 * @param {*} isExpand 
 * @returns 
 */
 function toggleRowExpansionAll(data, tableRef, isExpand) {
    if (!data.length) return;
      if (!tableRef) return;
      if (tableRef.getTable) tableRef = tableRef.getTable();
      // 循环数据，看是否有子节点
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        if (item.children && item.children.length > 0) {
          // 有子节点就触发展开折叠
          tableRef.toggleRowExpansion(item, isExpand);
          // 继续循环
          toggleRowExpansionAll(item.children, tableRef, isExpand);
        }
      }
}

export {
    downLoadFile,
    getTreeParent,
    getTreeSiblings,
    arrayChildrenFlatten,
    getBrowserClientId,
    showProgressColors,
    routerJump,
    textBecomeImg,
    colorRenderFilter,
    getMinusArray,
    convertStringTimeToDate,
    convertListStringTimeToDate,
    hasPermision,
    hasElement,
    hasFunciton,
    autoColor,
    calculateDelayDay,
    deepClone,
    getWeekSpanDate,
    groupBy,
    toggleRowExpansionAll
}

(function ($, h, c) {
    var a = $([]),
        e = $.resize = $.extend($.resize, {}),
        i,
        k = "setTimeout",
        j = "resize",
        d = j + "-special-event",
        b = "delay",
        f = "throttleWindow";
    e[b] = 250;
    e[f] = true;
    $.event.special[j] = {
        setup: function () {
            if (!e[f] && this[k]) {
                return false;
            }
            var l = $(this);
            a = a.add(l);
            $.data(this, d, {
                w: l.width(),
                h: l.height()
            });
            if (a.length === 1) {
                g();
            }
        },
        teardown: function () {
            if (!e[f] && this[k]) {
                return false;
            }
            var l = $(this);
            a = a.not(l);
            l.removeData(d);
            if (!a.length) {
                clearTimeout(i);
            }
        },
        add: function (l) {
            if (!e[f] && this[k]) {
                return false;
            }
            var n;
            function m(s, o, p) {
                var q = $(this),
                    r = $.data(this, d);
                r.w = o !== c ? o : q.width();
                r.h = p !== c ? p : q.height();
                n.apply(this, arguments);
            }
            if ($.isFunction(l)) {
                n = l;
                return m;
            } else {
                n = l.handler;
                l.handler = m;
            }
        }
    };
    function g() {
        i = h[k](function () {
            a.each(function () {
                var n = $(this),
                    m = n.width(),
                    l = n.height(),
                    o = $.data(this, d);
                if (m !== o.w || l !== o.h) {
                    n.trigger(j, [o.w = m, o.h = l]);
                }
            });
            g();
        },
            e[b]);
    }
})(jQuery, window);